export default "__VITE_ASSET__0e8e58bd__"